<template lang="pug">
    .video-editor-crop-control
        dummy-cropper-control(ref="controller" v-if="canShowMedia" v-model="cropData" v-bind="cropperAttrs")
            video-player-control(v-bind="videoPlayerAttrs" @resize="playerResized")
        p.video-editor-crop-control__label Choose Crop Size
        radio-select-field(v-model="aspectRatio" :options="cropSizes"  mode="compact" :allowUnselect="true")
</template>

<script>
/*global _ */
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
export default {
    name: 'video-editor-crop-control',
    components: {
        'image-cropper': VueCropper,
    },
    props: {
        value: {},
        isActive: {
            type: [Boolean]
        },
        video: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            innerValue: this.value,
            aspectRatio: null,
            canShowMedia: false,
            videoMeta: this.video?.meta || {},
            cropperOptions: {},
            dimensions: {
                width: null,
                height: null,
            },
            widthScale: 1,
            cropData: {}, //@todo: Allow custom cropzone to be passed to cropper using cropData
        }
    },
    computed: {
        cropSizes() {
            return [
                {label: '2:2', value: 2 / 2},
                {label: '3:2', value: 3 / 2},
                {label: '4:3', value: 4 / 3},
                {label: '5:4', value: 5 / 4},
                {label: '7:5', value: 7 / 5},
                {label: '16:9', value: 16 / 9},
            ]
        },
        cropperAttrs() {
            return {
                reRenderOnInit: true,
                aspectRatio: this.aspectRatio,
                dimensions: this.dimensions,
                options: this.cropperOptions,
            }
        },
        videoPlayerAttrs() {
            return {
                asset: this.video,
                hideControls: true,
                clickToPlay: true,
                options: this.playerOptions
            }
        },
        playerOptions() {
            return {
                ...this.dimensions
            }
        }
    },
    watch: {
        cropData: {
            handler(val, oldVal) {
                const calcVal = this.calc(val)
                const calcOldVal = this.calc(oldVal)
                if (calcVal || calcOldVal) {
                    this.innerValue = calcVal
                    this.$emit('input', calcVal)
                }
            },
            deep: true
        },
        isActive(v) {
            if (v) {
                this.activateCropper()
            } else {
                this.deActivateCropper()
            }
        }
    },
    created() {

    },
    mounted() {
        const width = this.$el.clientWidth
        let height = this.$el.clientHeight
        const mediaWidth = this.videoMeta.dimensions?.width
        // find the scale factor between original media width and cropper width
        const scale = this.widthScale = width / mediaWidth
        if (mediaWidth) {
            // calculate scaled media height using scale factor
            const scaledHeight = scale * this.videoMeta.dimensions?.height
            if (scaledHeight) {
                height = Math.ceil(scaledHeight)
            }
        }
        this.dimensions = {width, height}

        this.cropperOptions = {
            data: {x: 0, y: 0, width, height},
        }

        this.canShowMedia = true
    },
    methods: {
        playerResized(e) {
            const cropper = this.$refs?.controller.cropper
            if (cropper && cropper.ready) {
                cropper.render()
            }
        },
        cropperReady(cropper) {
            this.isCropperReady = true
        },
        activateCropper() {
            const cropper = this.$refs.controller?.cropper
            if (cropper) {
                cropper.enable()
                cropper.resize()
            }
        },
        deActivateCropper() {
            const cropper = this.$refs.controller?.cropper
            if (cropper) {
                cropper.disable()
            }
        },
        calc(data) {
            // no crop defined
            if (_.isEmpty(data)) {
                return null
            }

            const {min, max, floor, ceil} = Math
            const {width: cropperWidth} = this.dimensions // cropper or player dimensions
            const videoDimensions = this.videoMeta?.dimensions || {} // video's original dimensions
            const {width: mediaWidth, height: mediaHeight} = videoDimensions
            const original = {x: 0, y: 0, ...videoDimensions}
            const {x, y, width, height} = data || {} // crop coordinates

            // calculate the scale factor between original media width and cropper's media size
            const scale = mediaWidth / cropperWidth
            // scale crop coordinates to original media dimensions
            const scaledData = {
                x: max(0, floor(x * scale)),
                y: max(0, y * scale),
                width: min(mediaWidth, ceil(width * scale)),
                height: min(mediaHeight, ceil(height * scale)),
            }

            // no crop if the copped size is same as the media size
            if (_.isMatch(original, scaledData)) {
                return null
            }

            return scaledData
        },
    }
}
</script>
